var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _rect5, _rect6, _g3, _path7, _rect7, _g4, _path8, _path9, _rect8, _g5, _path10, _rect9, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale1Tube3Wet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 191,
    viewBox: "0 0 170 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 100.69C12.4876 98.8643 14.8232 97.7225 17.3671 97.7225H152.633C155.177 97.7225 157.512 98.8643 158.703 100.69L167.529 114.222C169.044 116.544 166.971 119.341 163.735 119.341H6.26463C3.02878 119.341 0.955955 116.544 2.47064 114.222L11.2968 100.69Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 186.273,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 185.641,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 146.319C1.96533 130.334 14.9238 117.376 30.9089 117.376H140.074C156.059 117.376 169.017 130.334 169.017 146.319V187.145H1.96533V146.319Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 121.128C0 115.799 4.3195 111.48 9.64787 111.48H160.352C165.68 111.48 170 115.799 170 121.128V185.179H0V121.128Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 168.409C149.364 173.738 145.045 178.057 139.716 178.057L29.3012 178.057C23.9728 178.057 19.6533 173.737 19.6533 168.409L19.6533 119.277L149.364 119.278L149.364 168.409Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9177_16857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 122.289H22.6011V153.891H146.416V122.289Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7556 122.289L34.1785 153.891H72.6147L132.587 122.289H93.7556Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.078 122.289L75.9858 153.891H80.1775L139.662 122.289H135.078Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 122.289H23.8875C23.177 122.289 22.6011 122.865 22.6011 123.575V154.246C22.6011 154.957 23.177 155.533 23.8875 155.533H147.783C148.493 155.533 149.069 154.957 149.069 154.246V123.575C149.069 122.865 148.493 122.289 147.783 122.289Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 102.212,
    width: 34.8025,
    height: 6.32038,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 95.8921,
    rx: 62.6445,
    ry: 11.3767,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 93.9958,
    rx: 63.5937,
    ry: 12.0087,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9177_16857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 156.568V161.07V183.582H69.3578V175.863H64.8555L69.3578 171.361V161.07H101.517L106.02 156.568Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9177_16857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3951 169.589V168.535L79.1956 164.627H76.5572V163.465H80.8705V164.51L78.07 168.427H80.9425V169.589H76.3951ZM83.783 169.697C82.3603 169.697 81.6399 169.021 81.6399 167.698V166.779C81.6399 165.474 82.3603 164.78 83.729 164.78C85.1067 164.78 85.8271 165.492 85.8271 166.797V167.653H82.9726V167.743C82.9726 168.355 83.2158 168.652 83.7921 168.652C84.2423 168.652 84.5034 168.472 84.5304 168.148H85.8001C85.7461 169.165 85.0527 169.697 83.783 169.697ZM82.9726 166.716H84.5665C84.5665 166.086 84.3323 165.825 83.774 165.825C83.2067 165.825 82.9726 166.086 82.9726 166.716ZM86.7882 169.589V164.888H87.9228L87.9768 165.762C88.1569 165.095 88.5261 164.798 89.1745 164.798H89.5256V166.041H89.2735C88.5802 166.041 88.247 166.302 88.1209 166.959V169.589H86.7882ZM92.1456 169.697C90.7228 169.697 90.0115 169.021 90.0115 167.671V166.806C90.0115 165.456 90.7228 164.78 92.1456 164.78C93.5683 164.78 94.2797 165.456 94.2797 166.806V167.671C94.2797 169.021 93.5683 169.697 92.1456 169.697ZM92.1456 168.616C92.7129 168.616 92.947 168.328 92.947 167.644V166.833C92.947 166.149 92.7129 165.861 92.1456 165.861C91.5783 165.861 91.3442 166.149 91.3442 166.833V167.644C91.3442 168.328 91.5783 168.616 92.1456 168.616Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 100,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 63 100)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9177_16857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 84,
    width: 38,
    height: 14
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 98,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 65 98)",
    fill: "#99DFF9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9177_16857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 98,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 65 98)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8846 96.2788C68.0823 96.2788 65 93.1965 65 89.3943C65 85.592 68.0823 82.5097 71.8846 82.5097L103.974 82.5097L103.974 92.2788C103.974 94.488 102.183 96.2788 99.9744 96.2788L71.8846 96.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 86L63 83L104 83L104 86L63 86Z",
    fill: "#F2F7FC"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1072 95.0282C56.45 95.5368 55.4951 95.0684 55.4951 94.2374L55.4951 88.2082C55.4951 87.4106 56.3832 86.934 57.0479 87.3749L61.109 90.069L61.109 91.931L57.1072 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9177_16857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 88,
    width: 3,
    height: 6
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 63.604 88.8276)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9177_16857)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 63.604 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81 88.2069C62.1313 88.2069 62.41 88.4255 62.4661 88.7419C62.556 89.2482 62.6685 90.0682 62.6685 91C62.6685 91.9318 62.556 92.7517 62.4661 93.2581C62.41 93.5745 62.1313 93.7931 61.81 93.7931C61.4229 93.7931 61.1091 93.4793 61.1091 93.0922L61.1091 88.9078C61.1091 88.5207 61.4229 88.2069 61.81 88.2069Z",
    fill: "#EEEEEE"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3574 94.5149C53.7027 94.7655 53 94.2821 53 93.581L53 88.9382C53 88.266 53.65 87.7852 54.2928 87.982L61.1089 90.0689L61.1089 91.931L54.3574 94.5149Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.893 95.0282C112.55 95.5368 113.505 95.0684 113.505 94.2374L113.505 88.2082C113.505 87.4106 112.617 86.934 111.952 87.3749L107.891 90.069L107.891 91.931L111.893 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9177_16857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 88,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 105.396 88.8276)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9177_16857)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 105.396 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.19 88.2069C106.869 88.2069 106.59 88.4255 106.534 88.7419C106.444 89.2482 106.332 90.0682 106.332 91C106.332 91.9318 106.444 92.7517 106.534 93.2581C106.59 93.5745 106.869 93.7931 107.19 93.7931C107.577 93.7931 107.891 93.4793 107.891 93.0922L107.891 88.9078C107.891 88.5207 107.577 88.2069 107.19 88.2069Z",
    fill: "#EEEEEE"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.643 94.5149C115.297 94.7655 116 94.2821 116 93.581L116 88.9382C116 88.266 115.35 87.7852 114.707 87.982L107.891 90.0689L107.891 91.931L114.643 94.5149Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 82,
    width: 18,
    height: 12,
    transform: "rotate(90 91 82)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5386 95.644C83.6666 95.644 82.6706 94.84 82.6706 93.34L82.6706 93.04L83.7026 93.04L83.7026 93.196C83.7026 94.18 84.3146 94.684 85.5386 94.684C86.7026 94.684 87.3506 94.228 87.3506 93.232C87.3506 92.296 86.7746 91.816 85.5146 91.816L84.6146 91.816L84.6146 90.856L85.5266 90.856C86.5946 90.856 87.1586 90.412 87.1586 89.536C87.1586 88.636 86.5706 88.156 85.5146 88.156C84.4106 88.156 83.8106 88.684 83.8106 89.632L83.8106 89.74L82.7906 89.74L82.7906 89.56C82.7906 88.06 83.7986 87.196 85.5506 87.196C87.2306 87.196 88.2026 88 88.2026 89.44C88.2026 90.328 87.8306 90.94 87.0986 91.252L87.0986 91.276C87.9866 91.576 88.4066 92.236 88.4066 93.268C88.4066 94.864 87.3866 95.644 85.5386 95.644Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7367 94.2368C70.7367 94.9781 70.1358 95.5789 69.3946 95.5789C68.6534 95.5789 68.0525 94.9781 68.0525 94.2368C68.0525 93.4956 69.3946 92 69.3946 92C69.3946 92 70.7367 93.4956 70.7367 94.2368Z",
    fill: "#00AEEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7763 97.2368C76.7763 97.9781 76.1754 98.5789 75.4341 98.5789C74.6929 98.5789 74.092 97.9781 74.092 97.2368C74.092 96.4956 75.4341 95 75.4341 95C75.4341 95 76.7763 96.4956 76.7763 97.2368Z",
    fill: "#00AEEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5656 86.2368C95.5656 86.9781 94.9647 87.5789 94.2235 87.5789C93.4822 87.5789 92.8813 86.9781 92.8813 86.2368C92.8813 85.4956 94.2235 84 94.2235 84C94.2235 84 95.5656 85.4956 95.5656 86.2368Z",
    fill: "#00AEEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.289 95.1842C104.289 95.9255 103.689 96.5263 102.947 96.5263C102.206 96.5263 101.605 95.9255 101.605 95.1842C101.605 94.443 102.947 92.9474 102.947 92.9474C102.947 92.9474 104.289 94.443 104.289 95.1842Z",
    fill: "#00AEEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8814 94.8174C92.8814 95.4197 92.3806 95.9079 91.763 95.9079C91.1453 95.9079 90.6445 95.4197 90.6445 94.8174C90.6445 94.2152 91.763 93 91.763 93C91.763 93 92.8814 94.2152 92.8814 94.8174Z",
    fill: "#00AEEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8815 87.3552C75.8815 88.0965 75.2806 88.6974 74.5394 88.6974C73.7981 88.6974 73.1973 88.0965 73.1973 87.3552C73.1973 86.614 74.5394 85.1184 74.5394 85.1184C74.5394 85.1184 75.8815 86.614 75.8815 87.3552Z",
    fill: "#00AEEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 93.398C59.9999 93.8613 59.5993 94.2368 59.1052 94.2368C58.611 94.2368 58.2104 93.8613 58.2104 93.398C58.2104 92.9348 59.1052 92 59.1052 92C59.1052 92 59.9999 92.9348 59.9999 93.398Z",
    fill: "#00AEEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0263 92.398C98.0263 92.8613 97.6257 93.2368 97.1316 93.2368C96.6374 93.2368 96.2368 92.8613 96.2368 92.398C96.2368 91.9348 97.1316 91 97.1316 91C97.1316 91 98.0263 91.9348 98.0263 92.398Z",
    fill: "#00AEEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111 89.648C111 90.1113 110.599 90.4868 110.105 90.4868C109.611 90.4868 109.21 90.1113 109.21 89.648C109.21 89.1848 110.105 88.25 110.105 88.25C110.105 88.25 111 89.1848 111 89.648Z",
    fill: "#00AEEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0395 90.0954C66.0395 90.5587 65.6389 90.9342 65.1447 90.9342C64.6506 90.9342 64.25 90.5587 64.25 90.0954C64.25 89.6321 65.1447 88.6974 65.1447 88.6974C65.1447 88.6974 66.0395 89.6321 66.0395 90.0954Z",
    fill: "#00AEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9177_16857"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6011,
    y: 122.289,
    width: 123.815,
    height: 31.6019,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale1Tube3Wet);
export default __webpack_public_path__ + "static/media/Scale_1Tube_3_wet.8327d592838adb9f0f1b15461faf4cd2.svg";
export { ForwardRef as ReactComponent };